import { useAuthContext } from '@contexts/authContext'
import { PiArrowRightBold } from 'react-icons/pi'
import { useNavigate } from 'react-router-dom'
import { fontSize, size } from '@styles/theme'
import useYesOrNo from '@hooks/useYesOrNo'
import YesOrNo from '@elements/YesOrNo'
import styled from '@emotion/styled'
import { SectionWrapper } from './AccountElements'
import { ButtonBase } from '@mui/material'

const LogoutButton = styled(ButtonBase)`
  background-color: #141414;
  border-radius: 100px;
  flex-shrink: 0;
  font-weight: bold;
  font-size: ${fontSize('md')};
  padding: ${size(2)};
  width: 100%;
  border: 0.5px solid rgba(255,255,255, 0.15);
`

const AccountLogoutSection = () => {
  const { logout } = useAuthContext()
  const navigate = useNavigate()
  const [isLogoutDialogOpen, openLogoutDialog, closeLogoutDialog] = useYesOrNo('account-logout-confirmation')

  const handleLogout = () => logout()
    .then(() => navigate('/landing'))
    .finally(() => window.location.reload())

  // Logout handler for YesOrNo
  const handleLogoutYesOrNo = (yesOrNo) => {
    if(yesOrNo) {
      handleLogout()
    }
    closeLogoutDialog()
  }

  return (
    <>
      <YesOrNo
        isOpen={isLogoutDialogOpen}
        setClosed={closeLogoutDialog}
        handleSelect={handleLogoutYesOrNo}
        title='Log Out of Mandrake?'
        body={<div style={{ textAlign: 'center' }}>🌈 Come back soon!</div>}
      />
      <SectionWrapper>
      <LogoutButton onClick={() => openLogoutDialog()}>
          Mandrake Sign Out&nbsp;
          <PiArrowRightBold size={size(2.5)} />
        </LogoutButton>
      </SectionWrapper>
    </>
  )
}

export default AccountLogoutSection
